<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
    <path
      d="M8.86198 16.4213L15.7237 12.4685C16.0921 12.2563 16.0921 11.7437 15.7237 11.5314L8.86198 7.57872C8.48262 7.36017 8 7.62255 8 8.04727L8 15.9527C8 16.3775 8.48262 16.6398 8.86198 16.4213Z"
    />
  </svg>
</template>
